import { render, staticRenderFns } from "./basicFAQ.vue?vue&type=template&id=73d9c346&scoped=true"
import script from "./basicFAQ.vue?vue&type=script&lang=js"
export * from "./basicFAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9c346",
  null
  
)

export default component.exports